import React, { useEffect, useState } from 'react';

// Material UI
import { Divider, List, IconButton, Badge } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { useTheme, useMediaQuery } from '@material-ui/core';

//Components
import RecursiveListNode from './RecursiveListNode';
import { menuItemFilter, cerrarSesion, tecnoRouteList } from '../../routes/routeList';

// Styles
import LogoN from '../../logos/LogoN.svg';
import LogoNovaLight from '../../logos/LogoNovaLight.svg';
import '../../styles/menu.css';
import StyledDrawer from './StyledDrawer';
import { getLogo } from '../../logos';
import Cookies from 'universal-cookie';
import { useGeneral } from '../../Context/GeneralContext';

const THEME_COLORS = {
    tecnoTheme:   { selectedBg: '#253139', iconActive: '#EB7D1E', iconDefault: '#FFFFFF' },
    posTheme:     { selectedBg: '#00638D', iconActive: '#118DFF', iconDefault: '#FFFFFF' },
    colTheme:     { selectedBg: '#3F4A51', iconActive: '#EB7D1E', iconDefault: '#FFFFFF' },
    matteTheme:   { selectedBg: '#253139', iconActive: '#EB7D1E', iconDefault: '#FFFFFF' },
    skyTheme:     { selectedBg: '#001B69', iconActive: '#118DFF', iconDefault: '#FFFFFF' },
    vaisandTheme: { selectedBg: '#001F66', iconActive: '#FF400D', iconDefault: '#FFFFFF' },
};
const defaultColors = { selectedBg: '#472A7A', iconActive: '#FFC800', iconDefault: '#C8AFE8' };

let menuBgColor = '#3F4A51';
if (process.env.REACT_APP_THEME === 'novaTheme') menuBgColor = '#5E3F94';
else if (process.env.REACT_APP_THEME === 'tecnoTheme') menuBgColor = '#3F4A51';
else if (process.env.REACT_APP_THEME === 'colTheme') menuBgColor = '#3F4A51';
else if (process.env.REACT_APP_THEME === 'matteTheme') menuBgColor = '#253139';
else if (process.env.REACT_APP_THEME === 'posTheme') menuBgColor = '#00638D';
else if (process.env.REACT_APP_THEME === 'skyTheme') menuBgColor = '#001B69';
else if (process.env.REACT_APP_THEME === 'vaisandTheme') menuBgColor = '#1A3566';


const Menu = () => {
    const { infoUser, notify, hasAccess } = useGeneral();
    const [selectedItem, setSelectedItem] = useState();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [openItem, setOpenItem] = useState();
    const [nombre, setNombre] = useState();
    const [linea, setLinea] = useState();
    const [mobileOpen, setMobileOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const logo = drawerOpen ? getLogo(process.env.REACT_APP_THEME) : LogoN;

    const showSecondaryLogo =
        (process.env.REACT_APP_THEME === 'tecnoTheme' && drawerOpen) ||
        (process.env.REACT_APP_THEME === 'colTheme' && drawerOpen) ||
        (process.env.REACT_APP_THEME === 'matteTheme' && drawerOpen) ||
        (process.env.REACT_APP_THEME === 'posTheme' && drawerOpen) ||
        (process.env.REACT_APP_THEME === 'vaisandTheme' && drawerOpen);

    useEffect(() => {
        const colors = THEME_COLORS[process.env.REACT_APP_THEME] ?? defaultColors;
        document.documentElement.style.setProperty('--menu-selected-bg', colors.selectedBg);
        document.documentElement.style.setProperty('--menu-icon-active', colors.iconActive);
        document.documentElement.style.setProperty('--menu-icon-default', colors.iconDefault);
    }, []);

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, [drawerOpen]);

    useEffect(() => {
        const cookie = new Cookies();
        setLinea(cookie.get('nombreL'));
        setNombre(cookie.get('nombre'));
    }, [infoUser]);

    // Cierra el drawer móvil al navegar
    useEffect(() => {
        if (isMobile) setMobileOpen(false);
    }, [selectedItem, isMobile]);

    const menuItems = (isMobileMode) => {
        return tecnoRouteList.map((item, idx) => {
            if (Object.keys(menuItemFilter).includes(item.id) && !menuItemFilter[item.id]) return null;
            if (item.id === 'build-info') return null;
            if (item.id === 'tv') return null;
            // Gating por rol según la matriz (viewPermissions).
            if (!hasAccess(item.id)) return null;
            return (
                <RecursiveListNode
                    node={item}
                    key={idx}
                    drawerOpen={isMobileMode ? true : drawerOpen}
                    openItem={openItem}
                    setDrawerOpen={isMobileMode ? setMobileOpen : setDrawerOpen}
                    setOpenItem={setOpenItem}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                />
            );
        });
    };

    const drawerContent = (isMobileMode) => (
        <>
            <div
                className={`menu-logo__wrapper ${isMobileMode || drawerOpen ? '' : 'closed'}`}
                onClick={() => isMobileMode ? setMobileOpen(false) : setDrawerOpen(!drawerOpen)}
            >
                <img
                    src={isMobileMode ? getLogo(process.env.REACT_APP_THEME) : logo}
                    className={`logo-pp-${process.env.REACT_APP_THEME}`}
                    alt="logo-pp"
                />
            </div>
            <div
                className={`menuView-line-name${(!isMobileMode && !drawerOpen) ? ' menuView-line-name--hidden' : ''}`}
            >
                {linea && <h4>{linea}</h4>}
                <h5>{nombre}</h5>
            </div>

            <Divider />

            <div className="menu-items-scroll">
                <List component="div" disablePadding>
                    {menuItems(isMobileMode)}
                </List>
            </div>

            <div className="menu-bottom">
                <div className="menu-logo-nova__wrapper">
                    {(isMobileMode || showSecondaryLogo) && (
                        <div>
                            <img src={LogoNovaLight} className="logo-nova" alt="logo-nova" />
                        </div>
                    )}
                </div>

                <Divider />
                <div className="LogOut">
                    <Divider />
                    <List component="div" disablePadding>
                        {cerrarSesion.map((item, idx) => (
                            <RecursiveListNode
                                node={item}
                                drawerOpen={isMobileMode ? true : drawerOpen}
                                key={idx}
                                openItem={openItem}
                                setOpenItem={setOpenItem}
                                selectedItem={selectedItem}
                                setSelectedItem={setSelectedItem}
                            />
                        ))}
                    </List>
                </div>
            </div>
        </>
    );

    if (isMobile) {
        return (
            <>
                <div className="mobile-menu-button">
                    <Badge badgeContent={notify} color="error" overlap="circular">
                        <IconButton onClick={() => setMobileOpen(true)}>
                            <img src={LogoN} alt="menu" />
                        </IconButton>
                    </Badge>
                </div>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    PaperProps={{
                        style: {
                            background: menuBgColor,
                            color: '#fff',
                            width: '18.25rem',
                        },
                    }}
                >
                    {drawerContent(true)}
                </Drawer>
            </>
        );
    }

    return (
        <div className="menuView">
            <StyledDrawer open={drawerOpen}>
                {drawerContent(false)}
            </StyledDrawer>
        </div>
    );
};

export default Menu;
